import {
  INotificationConfig,
  ModalComponent,
  NotififcationPresets,
  SystemNotifiactionIcon,
} from '@/ui/molecules/SystemNotifications/notifications.type'
import { t } from '@lingui/macro'
import style from './style.module.scss'
import { Trans } from '@lingui/react'
// import { SVG } from '@/assets/svg'
import clsx from 'clsx'
// import { memo } from 'react'

interface IBinanceTechnicalWorkAlertConfig {
  isMobile: boolean
  pinEnabled: boolean
}

export function getPinCodeAlert({ isMobile, pinEnabled }: IBinanceTechnicalWorkAlertConfig): INotificationConfig {
  const now = new Date().getTime()

  const endDate = new Date('2025-04-11')
  endDate.setHours(23, 59, 59, 999)

  const preset: INotificationConfig = {
    id: NotififcationPresets.PinCodeAlert,
    icon: SystemNotifiactionIcon.Alert,
    heading: (
      <span className={clsx(isMobile && style.mobile, style.label)}>
        <Trans
          id={'core.systemAlert.pincod.description'}
          components={{
            gradientText: <span className={style.gradient} />,
          }}
        />
      </span>
    ),
    description: <Trans id="core.systemAlert.pincod.label" />,
    // Modal: getModalComponent({ isMobile }),
    // shouldShown: now <= endDate.getTime() && !pinEnabled,
    shouldShown: false,
    availableExchange: ['TIGER_X', 'BINANCE_BROKER_FUTURE', 'BYBIT_BROKER', 'OKX_AFFILIATE'],
    // isClosable: true,
    link: {
      uri: 'https://broker-docs.tiger.com/vyvod-sredstv/zashita-vyvoda-pin-kodom',
      external: true,
    },
  }

  return preset
}
